import { ModalMenuStateSchema } from "../types/ModalMenuTypes";

export const getModalMenuState = (state: ModalMenuStateSchema) =>
  state.modalMenu.isVisible;
